import React from "react";
import { Helmet } from "react-helmet";

export default function Privacy() {
  return (
    <div style={{
      maxWidth: "900px",
      margin: "20px auto",
      padding: "20px 15px",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.8",
      color: "#1a1a1a",
      backgroundColor: "#fdfdfd",
      borderRadius: "8px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
    }}>
      {/* SEO Meta */}
      <Helmet>
        <title>Privacy Policy | GameHub</title>
        <meta name="description" content="Learn how GameHub (gamehub.samsoftix.com) collects, uses, and safeguards your data, including cookies and third-party ads." />
      </Helmet>

      <h1 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "20px", color: "#0d47a1" }}>
        Privacy Policy
      </h1>

      <p style={{ fontSize: "1rem" }}>
        At GameHub, accessible through <a href="https://gamehub.samsoftix.com" style={{ color: "#0d47a1" }}>gamehub.samsoftix.com</a>, we are committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and games.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Information We Collect</h2>
      <p style={{ fontSize: "1rem" }}>
        We may collect non-personal analytical data such as:
      </p>
      <ul style={{ paddingLeft: "20px", fontSize: "1rem", color: "#333" }}>
        <li>Browser type</li>
        <li>Device type (mobile/desktop/tablet)</li>
        <li>IP region (not exact IP)</li>
        <li>Pages visited and time spent</li>
        <li>Game interactions and performance metrics</li>
      </ul>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Cookies</h2>
      <p style={{ fontSize: "1rem" }}>
        We use cookies to enhance gameplay functionality, remember preferences, and analyze usage. 
        You may disable cookies in your browser settings, but some features may not function fully.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Third-Party Services</h2>
      <p style={{ fontSize: "1rem" }}>
        Our website may use third-party services such as Google AdSense, Google Analytics, and advertising networks.
        These services may use cookies to display personalized ads and measure engagement.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Advertising (AdSense)</h2>
      <p style={{ fontSize: "1rem" }}>
        We may display ads provided by Google AdSense or other ad providers. Google may use cookies
        to serve ads based on your prior visits to this or other websites. Users may opt-out of personalized
        advertising via their Google account settings.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Data Security</h2>
      <p style={{ fontSize: "1rem" }}>
        We do not sell, trade, or rent any data. We employ standard security practices to protect any 
        non-personal analytical information collected.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Children’s Privacy</h2>
      <p style={{ fontSize: "1rem" }}>
        GameHub may contain games accessible to users of all ages. We do not knowingly collect personal
        information from children under 13. If you believe a minor has shared personal information,
        please contact us for removal.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Changes to this Policy</h2>
      <p style={{ fontSize: "1rem" }}>
        We may update this Privacy Policy from time to time. Updates will be posted on this page with
        a new revision date.
      </p>

      <h2 style={{ fontSize: "1.5rem", marginTop: "30px", color: "#0d47a1" }}>Contact Us</h2>
      <p style={{ fontSize: "1rem" }}>
        If you have any questions about this Privacy Policy, you may contact us at:
        <br /><br />
        Email: <a href="mailto:samsoftix@gmail.com" style={{ color: "#0d47a1" }}>samsoftix@gmail.com</a>
      </p>

      <p style={{ marginTop: "30px", fontSize: "0.875rem", color: "#555" }}>
        Last updated: {new Date().toDateString()}
      </p>
    </div>
  );
}
